<template>
  <div class="my-input">
    <Poptip v-if="tips" trigger="hover">
      <Input v-model="inputData" :disabled="disabled" style="height:30px;" @on-blur="toFixedNumber">
        <span v-if="prependText" slot="prepend">{{ prependText }}</span>
        <span slot="append">{{ appendText }}</span>
      </Input>
      <div slot="content">{{ tips }}</div>
    </Poptip>
    <Input v-else v-model="inputData" :disabled="disabled" :maxlength="15" :placeholder="placeholder" @on-blur="toFixedNumber">
      <span v-if="prependText" slot="prepend">{{ prependText }}</span>
      <span slot="append">{{ appendText }}</span>
    </Input>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    defaultData: {
      type: Number | String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    prependText: { // 输入框前缀
      type: String
    },
    appendText: { // 输入框后缀
      type: String,
      default: '%'
    },
    toFixed: { // 格式化几位小数
      type: Number,
      default: 0
    },
    tips: { // 气泡提示
      type: String
    },
    placeholder: {
      type: String,
      default: '请输入金额'
    }
  },
  data () {
    return {
      inputData: ''
    }
  },
  watch: {},
  created() {},
  beforeMount() {
    if (typeof this.defaultData === 'number') {
      this.inputData = this.defaultData
      this.toFixedNumber()
    }
  },
  mounted() {},
  updated() {},
  methods: {
    toShow() {
      if (typeof this.defaultData === 'number') {
        this.inputData = this.defaultData
        this.toFixedNumber()
      }
    },
    toFixedNumber() {
      // 判断是否为正数
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
      if (!reg.test(this.inputData)) {
        this.inputData = ''
        this.$emit('getValue', this.inputData)
        return
      }
      this.inputData = Number(this.inputData).toFixed(this.toFixed)
      this.$emit('getValue', this.inputData)
    },
    // 清除数值
    clearValue() {
      this.inputData = ''
      this.$emit('getValue', this.inputData)
    }
  }
}
</script>
<style lang="scss">
.my-input{
    line-height: 1;
    .ivu-input-group-prepend, .ivu-input-group-append{
        background: #fff;
    }
    .ivu-poptip,.ivu-poptip-rel{
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/myInput/myInput.vue